module.exports = __webpack_public_path__ + "static/media/settings.6c1c5ff0.ico";